export default {
  toolBar: {
    preview: {
      title: 'プレビュー',
      tipsContext:
        '自動的にプレビューページに移動しない場合は、クリックしてください',
      tipsLink: 'リンク',
      full: '完全なプレビュー',
      beginWith: '現在のシーンからプレビューを開始',
      disabledTip:
        '現在のプロジェクトには動画が追加されていないノードがあります。調整後に再試行してください。',
    },
    save: {
      title: '保存',
      success: '保存成功',
      error: '保存失敗',
    },
    projectName: 'プロジェクト情報',
    download: 'ダウンロード',
    preparing: '準備中...',
    saveActionError: 'アクションの保存に失敗しました',
    repeated:
      '現在のプロジェクトは既にこのブラウザで編集されています。同じプロジェクトは1つの編集ページでのみ許可されています。',
  },
  previewAction: {
    original: 'オリジナル',
    mute: 'ミュート',
  },
  navbarMiddle: {
    newGroup: {
      tips: 'グループ化 (Ctrl/Command + G)',
    },
    unGroup: {
      tips: 'グループ解除 (Ctrl/Command + Shift + G)',
    },
    copy: {
      tips: 'コピー (Ctrl/Command + C)',
      record: 'コピーがコピー ボードに記録されました',
    },
    move: {
      title: 'レイヤーの順序',
      moveToTop: 'トップに配置',
      moveToBottom: 'ボトムに配置',
      moveUp: '1レイヤー上へ移動',
      moveDown: '1レイヤー下へ移動',
    },
    paste: {
      success: '貼り付けが成功しました',
      title: '貼り付け',
      justPasteTheLayerEvent: 'レイヤーイベントのみを貼り付ける',
      justPasteTheLayerAppearance: '外観のみを貼り付ける',
      justPastePositionAndSize: '位置とサイズのみを貼り付ける',
      justPasteTheLayerAnimation: 'レイヤーアニメーションのみを貼り付ける',
      pasteLayer: '貼り付けレイヤー（Ctrl/Command + V）',
    },
    redo: {
      title: 'やり直す',
    },
    undo: {
      title: '取り消す',
    },
  },
  recoverySound: '音声を復元する',
  languageSelector: {
    placeholder: '選択してください',
    label: 'プレビュー言語の選択',
  },
}
